/**
 * Load an image for canvas drawing. Bundled assets resolve same-origin; remote avatars may fail CORS.
 * @param {string} src
 * @returns {Promise<HTMLImageElement|null>}
 */
export function loadImageAsset(src) {
  if (!src) return Promise.resolve(null);

  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.decoding = "async";
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = src;
  });
}
